<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="hero-text">Need help?</h1>
      <h2 class="subtitle-text">
        Contact us for any questions or problems you may have
      </h2>
    </div>

    <div class="features-container">
      <div class="box" style="text-align: center;">
        <p>Send us an email at <b>hello@monthlystart.com</b></p>
        <p>We are humans so we'll help you as soon as we can personally 😄</p>
        <p>Thank you!</p>
      </div>
    </div>
  </div>

  <NewsletterCTA />

  <CulDeSac />
</template>

<script>
import CulDeSac from "@/components/CulDeSac";
import NewsletterCTA from "@/components/NewsletterCTA";

export default {
  components: {
    CulDeSac,
    NewsletterCTA,
  },
  created() {
    window.scrollTo(0, 0);
  },
};
</script>

<style></style>
